<template>
    <div>
        <button
            v-for="iconName in options"
            :key="iconName"
            :style="{ display: inline ? 'inline' : 'block' }"
            class="icon-select"
            @click="onClick(iconName)"
        >
            <kgr-icon
                :icon-class="iconName"
                :highlight="iconName === value"
                :light="iconName !== value"
                :disabled="disabled"
            />
        </button>
    </div>
</template>

<script>
import Icon from '../../icon/Icon.vue';

export default {
    components: {
        'kgr-icon': Icon,
    },
    props: {
        value: {
            type: String,
            required: false,
            default: null,
        },
        options: {
            type: Array,
            required: true,
        },
        inline: {
            type: Boolean,
            required: false,
            default: true,
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            selection: null,
            nullable: null,
        };
    },
    watch: {
        value(newValue) {
            this.selection = newValue;
        },
        options() {
            if (this.selection !== null && !this.options.includes(this.selection)) {
                this.selection = null;
                this.update();
            }
        },
    },
    mounted() {
        this.selection = typeof this.value === 'undefined' ? null : this.value;
        this.nullDefault = this.defaultText ? this.defaultText : 'pleaseChooseAnOption';
    },
    methods: {
        update() {
            this.$emit('input', this.selection);
            this.$nextTick(() => {
                this.$emit('post-input', this.selection);
            });
        },
        displayOption(option) {
            if (this.display) {
                return typeof option[this.display] === 'function' ? option[this.display]() : option[this.display];
            }

            return this.$t(option);
        },
        onClick(iconName) {
            this.$emit('input', iconName);
            this.$nextTick(() => {
                this.$emit('post-input', iconName);
            });
        },
    },
};
</script>

<style scoped>
.icon-select {
    cursor: pointer;
    padding: 1rem;
}
.icon-select svg {
    vertical-align: bottom;
}
.icon-select:hover {
    background-color: var(--kgr-input-background-color);
}
</style>
